import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { upgradeHref } from './plan-limits';

/**
 * Go to the upgrade page, saying which limit brought the vendor there
 * (`?reason=maxLeads`), so the page can open on what they were missing.
 */
export function useUpgrade() {
  const navigate = useNavigate();
  return useCallback((reason?: string | null) => navigate(upgradeHref(reason)), [navigate]);
}
